// extracted by mini-css-extract-plugin
export default {"InBetweenWrapper":"InBetween_InBetweenWrapper__gv+eh","InBetween":"InBetween_InBetween__FvqoV","textWrapper":"InBetween_textWrapper__trnRE"};